import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import STSComponent from "../../STSComponent/STSComponent";
import './radio.scss';

class RadioButtons extends STSComponent {
  constructor (props) {
    super(props)
    this.updateRadioButton = this.updateRadioButton.bind(this)
    this.openEditCustom = this.openEditCustom.bind(this)
    this.openDeleteCustom = this.openDeleteCustom.bind(this)
  }

  shouldComponentUpdate (nextProps) {
    return JSON.stringify(nextProps) !== JSON.stringify(this.props)
  }

  updateRadioButton = (item) => () => {
    const { updateData, location, id } = this.props
    updateData(location, 'radio', id, item)
  }

  openEditCustom = (item) => () => {
    const { sendData, showModal } = this.props
    sendData(item.id, item.name)
    showModal(`Edit-item-custom-list-${item.id}`)
  }

  openDeleteCustom = (item) => () => {
    const { sendData, showModal } = this.props
    sendData(item.id, item.name)
    showModal(`Delete-custom-list-${item.id}`)
  }

  returnControls = (id) => {
    return <div className="edit-controls">
      <span
        className="form-text-subtitle-clickable-section edit-btn"
        onClick={this.openEditCustom(id)}
      >
        EDIT
      </span>
      <span> / </span>
      <span
        className="form-text-subtitle-clickable-section delete-btn"
        onClick={this.openDeleteCustom(id)}
      >
        DELETE
      </span>
    </div>
  }

  renderButtons = () => {
    const { data, selected, icon, editRadio } = this.props
    return data.map((item, i) => {
      const name = !editRadio ? item : item.name
      if (selected === item || selected === item.name) {
        return <div className="modal-row" key={i}>
          <span className="radio-button selected">
            {icon ? <FontAwesomeIcon icon={icon[i]} className="icon-report" alt="report icon" /> : null}
            {name}
          </span>
          {editRadio ? this.returnControls(item) : null}
        </div>
      }
      return <div className="modal-row" key={i}>
        <span className="radio-button"
          onClick={this.updateRadioButton(name)}>
          {icon ? <FontAwesomeIcon icon={icon[i]} className="icon-report" alt="report icon" /> : null}
          {name}
        </span>
        {editRadio ? this.returnControls(item) : null}
      </div>
    })
  }

  render () {
    const { styles } = this.props
    return <div className="radio-buttons-wrap" style={styles}>
      {this.renderButtons()}
    </div>
  }

  static propTypes = {
    data: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    styles: PropTypes.object,
    icon: PropTypes.array,
    editRadio: PropTypes.bool,
    showModal: PropTypes.func,
    sendData: PropTypes.func
  }
}

export default RadioButtons



// WEBPACK FOOTER //
// ./src/components/FormComponents/RadioButtons/RadioButtons.js